<template>
  <AppDrawer
    v-model="familyStore.ui.showFamilyDrawer"
    :has-padding="false"
    dialog-titel="Familjeabonnemang"
    drawer-extra-classes="scroll-pb-[450px]"
  >
    <FamilyPdpStart v-if="familyStore.ui.showPdpDrawerStart" />
    <div v-else>
      <FamilyDrawerNew v-if="familyStore.ui.showNewCustomerFlow" />
      <FamilyBankIdIdentify v-else-if="shouldShowBankIdIdentify" />

      <FamilyDrawerExistingCustomer
        v-if="
          familyStore.existingCustomer.hasPlans &&
          familyStore.existingCustomer.isIdentified
        "
      />
    </div>

    <div
      v-if="shouldShowFamilyInfo"
      class="pb-32 px-16 md:px-24 mb-32 border-b-md border-solid border-border-secondary"
    >
      <AppUsp :items="uspItems2" usp-direction="col" />
    </div>
    <FamilyInfoBox
      v-if="shouldShowFamilyInfo"
      class="px-16 md:px-24 pb-60"
      :no-background="true"
    />
    <FamilyDrawerBuyButtonSection v-if="debouncedShouldShowBuyButtonSection" />
  </AppDrawer>
</template>

<script setup lang="ts">
import { uspItems2 } from '../../repository/mock_data/familyData';
const familyStore = useFamilyStore();
const { isSafari } = useDeviceInfo();
const timeToWaitBeforeShowingBuyButtonSectionMs = isSafari ? 400 : 50;

const shouldShowFamilyInfo = computed(
  () =>
    (familyStore.existingCustomer.hasPlans &&
      familyStore.existingCustomer.isIdentified) ||
    familyStore.ui.showPdpDrawerStart ||
    familyStore.ui.showNewCustomerFlow,
);

const shouldShowBankIdIdentify = computed(
  () =>
    !familyStore.ui.showNewCustomerFlow &&
    (!familyStore.existingCustomer.isIdentified ||
      !familyStore.existingCustomer.hasPlans),
);

const shouldShowBuyButtonSection = computed(() => {
  if (!familyStore.ui.showFamilyDrawer) {
    return false;
  }

  if (familyStore.ui.showNewCustomerFlow) {
    return true;
  }

  return (
    familyStore.existingCustomer.isIdentified &&
    familyStore.existingCustomer.hasPlans
  );
});

const debouncedShouldShowBuyButtonSection: Ref<boolean> = ref(false);
const debounceShowBuyButtonSectionFn = useDebounceFn(
  () => shouldShowBuyButtonSection.value,
  timeToWaitBeforeShowingBuyButtonSectionMs,
);

watch(
  shouldShowBuyButtonSection,
  async () => {
    debouncedShouldShowBuyButtonSection.value =
      await debounceShowBuyButtonSectionFn();
  },
  { immediate: true },
);
</script>

<style scoped></style>
